export { default } from './EditAccordionBlock';

export const displayName = 'Accordion';
